export const METHODOLOGY_TABS = ['review', 'editDocument'] as const;

export const WEAKNESS_SCORE_THRESHOLD = 6;

export const STRENGTH_SCORE_THRESHOLD = 8;

export const CLIENT_FINDINGS_TABS = ['weaknesses', 'strengths'] as const;

export type ClientFindingsTab = (typeof CLIENT_FINDINGS_TABS)[number];

export const SCORE_VIEW_TABS = ['score', 'summary'] as const;

export const CLIENT_FINDINGS_TEXT = {
  weaknesses: {
    title: { en: 'Weaknesses', nb: 'Svakheter' },
    identifiedOne: { en: 'weakness identified', nb: 'svakhet identifisert' },
    identifiedOther: { en: 'weaknesses identified', nb: 'svakheter identifisert' },
    emptyTitle: { en: 'No weaknesses identified', nb: 'Ingen svakheter identifisert' },
    emptyDescription: {
      en: 'All sections of the execution plan score well.',
      nb: 'Alle deler av gjennomføringsplanen skårer godt.',
    },
  },
  strengths: {
    title: { en: 'Strengths', nb: 'Styrker' },
    identifiedOne: { en: 'strength identified', nb: 'styrke identifisert' },
    identifiedOther: { en: 'strengths identified', nb: 'styrker identifisert' },
    emptyTitle: { en: 'No strengths identified', nb: 'Ingen styrker identifisert' },
    emptyDescription: {
      en: 'No sections of the execution plan score very well.',
      nb: 'Ingen deler av gjennomføringsplanen skårer svært godt.',
    },
  },
};
